// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"117":"highlight-run","283":"logrocket","526":"html2canvas"}[chunkId] + "." + {"117":"b4d132275750b4c7e37a","283":"488e64bf23cb94d9cc56","526":"d5b72c360dac35860227"}[chunkId] + ".js";
};